import React from 'react';
import { iconMap } from '../utils/iconMap';

export default function Icon({ emoji, size = 18, ...props }) {
  const LucideIcon = iconMap[emoji];

  if (!LucideIcon) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`Icon: no lucide mapping for "${emoji}"`);
    }
    return <span role="img" aria-label={emoji} {...props}>{emoji}</span>;
  }

  return <LucideIcon size={size} {...props} />;
}
